import React from "react";

import { Button, Icon } from "antd";

const CreateNewQuestion = ({ onAdd }) => {
	return (
		<div className="NewVoting__item-block new-question" onClick={onAdd}>
			<Button type="link">
				<Icon type="plus-circle" />
				Добавить вопрос
			</Button>
		</div>
	);
};

export default CreateNewQuestion;
